<template>
  <div>
    <schedule-table :items="items" :headers="headers" type="member"/>
  </div>
</template>

<script>
  import scheduleTable from "./scheduleTable";
  export default {
    name: "mySchedule",
    components:{
      scheduleTable
    },
    data () {
      return {
        headers: [
          {
            text: this.$t('Day'),
            align: 'start',
            value: 'dayNameName',
            sortable: false
          },
          { text: this.$t('Type'), value: 'reservationTypeName',sortable: false },
          { text: this.$t('Sport'), value: 'sportActivityName',sortable: false },
          { text: this.$t('From'), value: 'fromTime',sortable: false },
          { text: this.$t('To'), value: 'toTime',sortable: false },
          { text: 'Actions', value: 'actions',sortable: false},
        ],
        items: [],
      }
    },
    mounted() {
      this.getSchedulesMember()
    },
    methods: {
      getSchedulesMember() {
        this.$http_sys.post('Schedule/GetScheduleMember', {
          lang: this.$i18n.locale
        })
          .then(res => {
            this.items = res.data[0].children
          })
          .catch(error => {

          })
      },
    },

    computed: {
    },

    watch: {

    },
  }
</script>

<style scoped>

</style>
